module.exports = __webpack_public_path__ + "img/11069853_L.e9f4a14e.png";